export function log(object) {
    var debug = !window.location.toString().includes("berlinerstadtwerke.de");
    if (debug && (new URLSearchParams(window.location.search)).get("trdebug")) {
        console.log(object);
    }
}
